import React from 'react';
import styles from './PremiumModal.module.css';
import { useLanguage } from '../Providers/LanguageContext';

interface PremiumModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function PremiumModal({ isOpen, onClose }: PremiumModalProps) {
  const { t } = useLanguage();

  if (!isOpen) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeButton} onClick={onClose}>
          &times;
        </button>

        <div className={styles.lockIcon}>🔒</div>
        <h2 className={styles.title}>{t('premium.title')}</h2>

        <div className={styles.starDivider}>✦</div>

        <div className={styles.content}>
          <p className={styles.mainMessage}>
            {t('premium.accessDenied')}
          </p>

          <ul className={styles.featureList}>
            <li className={styles.featureItem}>
              <span className={styles.featureIcon}>🎨</span>
              Custom board themes & piece skins
            </li>
            <li className={styles.featureItem}>
              <span className={styles.featureIcon}>📊</span>
              Advanced match analytics
            </li>
            <li className={styles.featureItem}>
              <span className={styles.featureIcon}>⚡</span>
              Priority matchmaking
            </li>
          </ul>

          <span className={styles.comingSoon}>coming soon</span>
        </div>
      </div>
    </div>
  );
}

export default PremiumModal;
